module.exports = __webpack_public_path__ + "img/4-1.9f8c3d38.svg";